import React from 'react';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol, ContenedorBoton } from '../componentes_generales/componentes_formulario/contenedores/';
import {LabelForm, LabelNota } from '../componentes_generales/componentes_formulario/labels/';
import { InputText }  from '../componentes_generales/componentes_formulario/inputs/inputtext';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import { cargarCatalogos,cargarCatalogosGenericoAsyncInvertido, cargarCatalogosAsync, cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';
import global_axios from '../../funciones_globales/interaccionapi';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';//Willy 2020-01-20 cambios en DCAMBIO Y CAMBIO

class FormInven03 extends React.Component{   
  constructor(props) {
    super(props);
    this.state = {   
      usuario:null,//Willy 2020-01-20 cambios en DCAMBIO Y CAMBIO        
      linea_sel: null,
      tipocompra_sel: null,
      procedencia_sel: null,
      marca_sel: null,
      sublinea_sel: null,
      articulo_sel: null,
      importacion_sel: null,
      lineas: [],          
      p_distribuidor: '',
      p_mayorista: '',
      p_detallista: '',
      pvp: '',
      descuento: '',      
      data_articulos: [],
      columnDefs: [ {   header: "Nro.",
                        field: "NroItem",
                        width: 40,
                        type: "string",
                        suppressSorting: true,
                        suppressFilter: true
                    },
                    {   header: "Cod. Artículo",
                        field: "Articulo",
                        width: 105,
                        type: "string"
                    },
                    {   header: "Nombre Artículo",
                        field: "Nombre",
                        width: 225,
                        type: "string"
                    },                   
                    {   header: "Costo Promedio",
                        field: "CostoPromedio",
                        width: 100,
                        type: "num_decimal",
                        suppressSorting: true,
                        suppressFilter: true
                    },                                        
                    {   header: "P. Distribuidor",
                        field: "PrecioDistribuidor",
                        width: 100,
                        type: "num_decimal_edit",
                        editable: true,
                        valueFormatter: this.formatearNumero,
                        suppressSorting: true,
                        suppressFilter: true
                    },
                    {   header: "P. Mayorista",
                        field: "PrecioMayorista",
                        width: 100,
                        type: "num_decimal_edit",
                        editable: true,
                        valueFormatter: this.formatearNumero,
                        suppressSorting: true,
                        suppressFilter: true
                    },      
                    {   header: "P. Detallista",
                        field: "PrecioDetallista",
                        width: 100,
                        type: "num_decimal_edit",
                        editable: true,
                        valueFormatter: this.formatearNumero,
                        suppressSorting: true,
                        suppressFilter: true
                    },                    
                    {   header: "Pvp.",
                        field: "Pvp",
                        width: 50,
                        type: "num_decimal_edit",
                        editable: true,
                        valueFormatter: this.formatearNumero,
                        suppressSorting: true,
                        suppressFilter: true
                    },  
                    {   header: "Dscto.",
                        field: "Descuento",
                        width: 50,
                        type: "num_decimal_edit",
                        editable: true,
                        valueFormatter: this.formatearNumero,
                        suppressSorting: true,  
                        suppressFilter: true
                    },  
                    {   header: "P. Mayo. Actual",
                        field: "PrecioMayoristaAnt",
                        width: 120,
                        type: "num_decimal_edit",
                        editable: false,
                        valueFormatter: this.formatearNumero,
                        suppressSorting: true,
                        suppressFilter: true
                    }                  
                  ]      
    };

    this.gridOptions = {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true
    };

    this.onGridReady = this.onGridReady.bind(this);   
    this.consultarArticulos = this.consultarArticulos.bind(this);    
    this.getOptions_TiposCompra = this.getOptions_TiposCompra.bind(this);
    this.getOptions_Procedencias = this.getOptions_Procedencias.bind(this);
    this.getOptions_Marcas = this.getOptions_Marcas.bind(this);
    this.getOptions_Sublineas = this.getOptions_Sublineas.bind(this);
    this.calcularPrecios_Dscto = this.calcularPrecios_Dscto.bind(this);
    this.immutablePush = this.immutablePush.bind(this);
    this.actualizarPorcentajesPreciosIngresados = this.actualizarPorcentajesPreciosIngresados.bind(this);
    this.submit = this.submit.bind(this);
    this.procesarGuardadoRecursivo = this.procesarGuardadoRecursivo.bind(this);
    this.formatearNumero = this.formatearNumero.bind(this);
    this.limpiar = this.limpiar.bind(this);
    this.validarPrecio = this.validarPrecio.bind(this);
  
    
  }  

  submit(e){
    e.preventDefault();
    if (this.state.data_articulos.length > 0){      
      
      
      if (this.validarPrecio(this.state.data_articulos)){
        console.log('PasoAqui')
        let guardar = window.confirm('¿Está seguro de actualizar los precios de los artículos?');      
        if (guardar){         
          console.log('PasoAqui')
          this.props.cambiar_VisualizacionLoading(true);
          this.procesarGuardadoRecursivo(this.state.data_articulos);
        }

      }
      
    }
  }

  formatearNumero(params){
    return parseFloat(params.value).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
  
  validarPrecio(data_articulos){
    
    let verificar = true
    let total_items = data_articulos.length;
    for(let i=0; i<total_items; i++){
      if (parseFloat(data_articulos[i].CostoPromedio)>parseFloat(data_articulos[i].PrecioMayorista) ){
        alert(`El precio del Articulo ${data_articulos[i].Articulo} es menor al costo promedio del mismo favor revisar, no se actualizara el precio .`)      
        verificar=false
      }
    }
    console.log(verificar)
    return verificar
  }

  procesarGuardadoRecursivo(data_articulos){
    
    let total_items = data_articulos.length;
    let lim_items_req = 400;    
    let articulos_tmp = [];
    let articulos_pend = [];
    let ult_item;

    for(let i=0; i<lim_items_req; i++){
      if (i<total_items){
        articulos_tmp.push(data_articulos[i]);
        ult_item = i;
      }
    }    

    if (ult_item){
      for(let j=ult_item+1; j<total_items; j++){      
        articulos_pend.push(data_articulos[j]);      
      }
    }

    let data = { det_cambio: articulos_tmp, usuario:this.state.usuario };//Willy 2020-01-20 cambios en DCAMBIO Y CAMBIO
    global_axios({
      method: 'POST',
      url: '/cambios',
      data
    })
    .then((response)=> {       
        if (  articulos_pend.length> 0 ){
          this.procesarGuardadoRecursivo(articulos_pend);
        }else{
          this.props.cambiar_VisualizacionLoading(false);
          alert("Se procesó correctamente la actualización de precios.");
        }
    })
    .catch((error) => {
      this.props.cambiar_VisualizacionLoading(false);
      if (error.response){
        alert(error.response.data.msg);         
      }else{
        alert(error.message);
      }
    });    
  }  

  onGridReady(params) {
    this.api = params.api;
    this.columnApi = params.columnApi;
  }
  
  componentDidMount() {
    Promise.all([
        cargarCatalogos('FORMA'),
        getItemDatosSesion('usuario'),
        this.props.generar_LogAuditoriaIngresoForm('0203')
    ])
    .then(([result_lineas,usuario]) => {
      this.setState(
        { lineas: result_lineas, usuario         
        })
    })
    .catch(err => {
      console.log(err);
    });        
  }

  componentWillMount(){
    this.props.generar_LogAuditoriaSalidaForm('0203');
  }

  getOptions_TiposCompra(input, callback){
    if (input.toString().length >= 2 ){
      cargarCatalogosAsync('TIPOPRECIO', input, callback)
    }
  }  

  getOptions_Procedencias(input, callback){
    if (input.toString().length >= 2 ){
      cargarCatalogosAsync('GRUPO', input, callback)
    }
  }
   
  getOptions_Marcas(input, callback){
    if (input.toString().length >= 2 ){
      cargarCatalogosAsync('LINEA', input, callback)
    }
  }  
  
  getOptions_Sublineas(input, callback){
    if (input.toString().length >= 2 ){
      cargarCatalogosAsync('SUBLINEA', input, callback)
    }
  }  

  getOptions_Articulos(input, callback){
    if (input.toString().length >= 3 ){
      let query = "?tipo=catalogo&cadena_busq=" + input;     
      cargarCatalogosGenericoAsync('/articulos', query, callback)
    }
  } 

  getOptions_Importaciones(input, callback){
    if (input.toString().length >= 3 ){
        let cadena_busq = '?cadena_busq=' + input;
        cargarCatalogosGenericoAsyncInvertido('/importaciones', cadena_busq, callback)  
    }
}

  consultarArticulos(){    
    const linea = this.state.linea_sel || undefined;
    const tipocompra = this.state.tipocompra_sel || undefined;
    const procedencia = this.state.procedencia_sel || undefined;
    const marca = this.state.marca_sel || undefined;
    const sublinea = this.state.sublinea_sel || undefined;
    const articulo = this.state.articulo_sel || undefined;
    const importacion = this.state.importacion_sel || undefined;
   
    if (  linea !== undefined ||
          tipocompra !== undefined ||
          procedencia !== undefined ||
          marca !== undefined ||
          sublinea !== undefined ||
          articulo !== undefined||
          importacion !== undefined){

      let url = '/articulos?tipo=general';
      
      url = url.concat((linea !== undefined)? '&forma=' + linea.value: '');
      url = url.concat((tipocompra !== undefined)? '&tipocompra=' + tipocompra.value: '');
      url = url.concat((procedencia !== undefined)? '&grupo=' + procedencia.value: '');
      url = url.concat((marca !== undefined)? '&linea=' + marca.value: '');
      url = url.concat((sublinea !== undefined)? '&sublinea=' + sublinea.value: '');
      url = url.concat((articulo !== undefined)? '&articulo=' + articulo.value: '');
      url = url.concat((importacion !== undefined)? '&importacion=' + importacion.value: '');
      
      console.log(url)
      this.props.cambiar_VisualizacionLoading(true);
      global_axios({
        method: 'GET',
        url: url,
      })
      .then((response)=> {
        this.props.cambiar_VisualizacionLoading(false);

        let data_articulos = response.data;
        let articulos = [];

        data_articulos.forEach((art, i) => {
          articulos.push({
            NroItem: i+1,
            Articulo: art.Articulo,
            Costo: parseFloat(art.Costo===null?0:art.Costo),
            CostoPromedio: parseFloat(art.CostoPromedio===null?0:art.CostoPromedio),
            CostoProveedor: parseFloat(art.CostoProveedor===null?0:art.CostoProveedor),
            Descuento: parseFloat(art.Descuento===null?0:art.Descuento),
            Nombre: art.Nombre,
            PrecioDetallista: parseFloat(art.PrecioDetallista===null?0:art.PrecioDetallista).toFixed(2),
            PrecioDistribuidor: parseFloat(art.PrecioDistribuidor===null?0:art.PrecioDistribuidor).toFixed(2),
            PrecioMayorista: parseFloat(art.PrecioMayorista===null?0:art.PrecioMayorista).toFixed(2),
            Pvp: parseFloat(art.Pvp===null?0:art.Pvp).toFixed(2),
            PrecioMayoristaAnt: parseFloat(art.PrecioMayorista===null?0:art.PrecioMayorista).toFixed(2),
          });
        });

        this.setState({data_articulos: articulos});
      })
      .catch((error)=> {
        this.props.cambiar_VisualizacionLoading(false);
        this.setState({data_articulos: []});
        alert(error.response?error.response.data.msg:error.message);
      });

    }else{
      alert('Debe especificar al menos un filtro de búsqueda.');
    }    
  }

  limpiar(){
    this.setState({
      linea_sel: undefined,
      tipocompra_sel: undefined,
      procedencia_sel: undefined,
      marca_sel: undefined,
      sublinea_sel: undefined,
      articulo_sel: undefined,
      importacion_sel: undefined,
      p_distribuidor: '',
      p_mayorista: '',
      p_detallista: '',
      pvp: '',
      descuento: '',
      data_articulos: []
    });
  }

  immutablePush(array, newItem){
    return [ ...array, newItem ];  
  }

  calcularPrecios_Dscto(){
    if (this.state.data_articulos.length>0){
      
      const p_distribuidor = this.state.p_distribuidor===''? 0: parseFloat(this.state.p_distribuidor);
      const p_mayorista = this.state.p_mayorista===''? 0: parseFloat(this.state.p_mayorista);
      const p_detallista = this.state.p_detallista===''? 0: parseFloat(this.state.p_detallista);
      const pvp = this.state.pvp===''? 0: parseFloat(this.state.pvp);
      const descuento = this.state.descuento===''? 0: parseFloat(this.state.descuento);      
      
      if (p_distribuidor>0 || p_mayorista>0 || p_detallista>0 || pvp>0 || descuento>=0){
        let articulos_calc = [];      

        this.state.data_articulos.forEach((art) => {
          let precioBase = parseFloat(art.CostoPromedio);
          let art_cal = {...art, 
                          PrecioDistribuidor: p_distribuidor >0 ? parseFloat((precioBase * (1 + p_distribuidor/100)).toFixed(2)): art.PrecioDistribuidor,
                          PrecioMayorista: p_mayorista >0 ? parseFloat((precioBase * (1 + p_mayorista/100)).toFixed(2)): art.PrecioMayorista,
                          PrecioDetallista: p_detallista >0 ? parseFloat((precioBase * (1 + p_detallista/100)).toFixed(2)): art.PrecioDetallista,
                          Pvp: pvp >0 ? parseFloat((precioBase * (1 + pvp/100)).toFixed(2)): art.Pvp,
                          Descuento: descuento >=0 ? parseFloat(descuento).toFixed(2): art.Descuento
                          
                        };

          articulos_calc = this.immutablePush(articulos_calc, art_cal);
        });

        this.setState({data_articulos: articulos_calc});    
      }
    }
  }

  actualizarPorcentajesPreciosIngresados(event){
    const target = event.target;
    const name = target.name;
    const value = target.value;
    this.setState({
      [name]: value
    });
  }

  render(){        
        return(
          <ContenedorForm porc_ancho={70}>
            <HeaderForm>
              <TituloForm>Mantenimiento de Precios</TituloForm>
            </HeaderForm>
            <CuerpoForm>
              <Row>
                <ContainerCol className='col-md-4'>
                  <LabelForm>Categoría:</LabelForm>
                  <ReactSelectAsync value={this.state.tipocompra_sel} func_loadOptions={this.getOptions_TiposCompra} 
                    func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({tipocompra_sel: value})}}/>
                </ContainerCol>
                <ContainerCol className='col-md-4'>
                  <LabelForm>Procedencia:</LabelForm>
                  <ReactSelectAsync value={this.state.procedencia_sel} func_loadOptions={this.getOptions_Procedencias} 
                    func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({procedencia_sel: value})}}/>
                </ContainerCol>
                <ContainerCol className='col-md-4'>
                  <LabelForm>Marca:</LabelForm>
                  <ReactSelectAsync value={this.state.marca_sel} func_loadOptions={this.getOptions_Marcas}
                    func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({marca_sel: value})}}/>
                </ContainerCol>
              </Row>
              <Row>                  
                <ContainerCol className='col-md-4'>
                  <LabelForm>Línea:</LabelForm>
                  <ReactSelect options={ this.state.lineas } value={this.state.linea_sel} 
                    func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({linea_sel: value})}}/>
                </ContainerCol>
                <ContainerCol className='col-md-4'>
                  <LabelForm>Sub-línea:</LabelForm>
                  <ReactSelectAsync value={this.state.sublinea_sel} func_loadOptions={this.getOptions_Sublineas}
                    func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({sublinea_sel: value})}}/>
                </ContainerCol>
                <ContainerCol className='col-md-4'>
                  <LabelForm>Artículo:</LabelForm>
                  <ReactSelectAsync value={this.state.articulo_sel} func_loadOptions={this.getOptions_Articulos} 
                    func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({articulo_sel: value})}}/>
                </ContainerCol>
                </Row>
                <Row>                  
                <ContainerCol className='col-sm-4'>
                      <LabelForm>Importacion.:</LabelForm>
                
                      <ReactSelectAsync value={this.state.importacion_sel} func_loadOptions={this.getOptions_Importaciones} 
                      func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({importacion_sel: value})}} />
                </ContainerCol>                 
                </Row>
                
                <Row margen_arriba={10}>
                  <ContainerCol className='col-md-2'>                    
                    <LabelForm>% P. Distribuidor:</LabelForm>
                    <InputText name='p_distribuidor' value={this.state.p_distribuidor} type="number" className='form-control input-sm' placeholder='% P. Distribuidor' onChange={this.actualizarPorcentajesPreciosIngresados}/>
                  </ContainerCol>     
                  <ContainerCol className='col-md-2'>                    
                    <LabelForm>% P. Mayorista:</LabelForm>
                    <InputText name='p_mayorista' value={this.state.p_mayorista} type="number" className='form-control input-sm' placeholder='% P. Mayorista' onChange={this.actualizarPorcentajesPreciosIngresados}/>
                  </ContainerCol>     
                  <ContainerCol className='col-md-2'>                    
                    <LabelForm>% P. Detallista:</LabelForm>
                    <InputText name='p_detallista' value={this.state.p_detallista} type="number" className='form-control input-sm' placeholder='% P. Minorista' onChange={this.actualizarPorcentajesPreciosIngresados}/>
                  </ContainerCol>     
                  <ContainerCol className='col-md-2'>                    
                    <LabelForm>% P.V.P.:</LabelForm>
                    <InputText name='pvp' value={this.state.pvp} type="number" className='form-control input-sm' placeholder='% P.V.P.' onChange={this.actualizarPorcentajesPreciosIngresados}/>
                  </ContainerCol>
                  <ContainerCol className='col-md-2'>                    
                    <LabelForm>% Descuento:</LabelForm>
                    <InputText name='descuento' value={this.state.descuento} type="number" className='form-control input-sm' placeholder='% Descuento' onChange={this.actualizarPorcentajesPreciosIngresados}/>
                  </ContainerCol>     
                  <ContainerCol className='col-md-1'>
                    <ContenedorBoton margen_arriba={20}>
                      <button type="button" className='btn btn-success btn-sm' onClick={ this.consultarArticulos }><i className="fa fa-search"/> Buscar</button>
                    </ContenedorBoton>
                  </ContainerCol>
                  <ContainerCol className='col-md-1'>
                    <ContenedorBoton margen_arriba={20}>
                      <button type="button" className='btn btn-info btn-sm' onClick={ this.calcularPrecios_Dscto }><i className="fa fa-calculator"/></button>
                    </ContenedorBoton>
                  </ContainerCol>                                 
                </Row>
                <form onSubmit={this.submit.bind(this)}>
                  <Row margen_arriba={5}>
                    <div className='col-md-12'>
                      <LabelNota>{`Resultado de búsqueda: ${this.state.data_articulos.length} artículos.`}</LabelNota>
                    </div>
                  </Row>
                  <Row>
                    <div className='col-md-12'>   
                      <AgGridRender altura='315px' data={this.state.data_articulos} columnas={this.state.columnDefs}
                        gridOptions={this.gridOptions} onGridReady={this.onGridReady}/>
                    </div>
                  </Row>
                  <Row>        
                    <div className='col-md-12'>
                      <div className='btn-group pull-right'>
                        <button type='submit' className='btn btn-primary btn-sm'><i className='fa fa-floppy-o fa-lg'></i> Guardar </button>
                        <button type='button' className='btn btn-default btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'></i> Limpiar </button>
                      </div>
                    </div>                  
                  </Row>  
                </form>
            </CuerpoForm>
          </ContenedorForm>
      );
  }
}

const mapStateToProps = ((state) => {
  return {isVisibleLoading: state.ui.isVisibleLoading}
});

const mapDispatchToProps = ((dispatch) => {  
  return bindActionCreators({ cambiar_VisualizacionLoading, generar_LogAuditoriaIngresoForm,
                              generar_LogAuditoriaSalidaForm }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormInven03);